/** Strings of an agent's purpose, its queue and what it does now (/agents cards, the Activity tab). */
export const agentWorkEn = {
  agentWork: {
    purpose: {
      label: "Purpose",
      owns: "Answers for",
      measures: "Measured by",
      reviewer: {
        text: "Turns a request into a clear brief, plan and criteria that can be verified. Settles disputes.",
        owns: "brief, plan, arbitration, review meetings",
        measures: "plan accepted first time, tickets returned over the brief",
      },
      metodej: {
        text: "Delivers a change that passes the checks and meets the criteria first time.",
        owns: "code, MR, green pipeline",
        measures: "done without a return, failed runs",
      },
      vratislav: {
        text: "Nothing that would harm the repository gets into it.",
        owns: "review, merge gate, health of the branches",
        measures: "returns after merge, time at the gate",
      },
      tester: {
        text: "Verifies on a running environment that the user really gets it.",
        owns: "verifying the criteria, evidence",
        measures: "bugs found before production, time in test",
      },
      "log-triage": {
        text: "We learn about production errors before the client does.",
        owns: "logs, alert tickets",
        measures: "share of false alarms, time to ticket",
      },
      "wiki-keeper": {
        text: "The documentation matches the application.",
        owns: "project wikis",
        measures: "outdated pages",
      },
      analyst: {
        text: "Nothing agreed in an email, a chat or a meeting gets lost.",
        owns: "ticket and time suggestions",
        measures: "accepted suggestions",
      },
    },
    now: {
      title: "Now",
      nothing: "Not running anything.",
      alive: "Up on {{instances}}, last asked for work",
      gone: "No instance has asked for work in the last 10 minutes: it isn't running.",
      phase: "Phase",
      lastRun: "Last run",
      noRuns: "No finished run yet.",
      since: "since",
      doing: "Doing",
      lanes_one: "{{count}} lane at work",
      lanes_few: "{{count}} lanes at work",
      lanes_other: "{{count}} lanes at work",
      runs: "Runs",
    },
    hold: {
      paused: "Paused: takes no work.",
      draining: "A deploy is in progress: takes no new work.",
      limited: "Waits for its subscription limit until",
      accessError: "Its access is refused: {{error}}",
    },
    queue: {
      title: "Queue",
      intro:
        "Open tickets it holds, in the order it takes them: running first, then what it would take next, then what it never acts on.",
      count_one: "{{count}} ticket",
      count_few: "{{count}} tickets",
      count_other: "{{count}} tickets",
      flagged_one: "{{count}} needs attention",
      flagged_few: "{{count}} need attention",
      flagged_other: "{{count}} need attention",
      empty: "It holds no open ticket.",
      loadFailed: "Couldn't load the queue.",
      open: "Open queue",
      waits: "no progress for {{age}}",
      flags: {
        running: "In progress",
        wrongState: "Never acts in this state",
        parked: "Waits on a dependency",
        note: "Stalled",
        escalate: "Stalled, goes to a person",
        handover: "Due for handover",
        plan: "Plan to judge",
        fallback: "Only when idle",
        recent: "Just ran, waits behind others",
        fallbackFree: "Only when idle, its turn now",
        backoff: "Waits after failed tries",
        criteria: "Waits for agreed criteria",
      },
    },
    age: {
      minutes_one: "{{count}} minute",
      minutes_few: "{{count}} minutes",
      minutes_other: "{{count}} minutes",
      hours_one: "{{count}} hour",
      hours_few: "{{count}} hours",
      hours_other: "{{count}} hours",
      days_one: "{{count}} day",
      days_few: "{{count}} days",
      days_other: "{{count}} days",
    },
  },
};

export const agentWorkCs: typeof agentWorkEn = {
  agentWork: {
    purpose: {
      label: "Smysl",
      owns: "Ručí za",
      measures: "Měří se",
      reviewer: {
        text: "Z požadavku udělá jasné zadání, plán a kritéria, která se dají ověřit. Rozhoduje spory.",
        owns: "zadání, plán, arbitráž, revizní schůzky",
        measures: "plán přijatý napoprvé, tikety vrácené kvůli zadání",
      },
      metodej: {
        text: "Dodá změnu, která projde kontrolami a splní kritéria napoprvé.",
        owns: "kód, MR, zelená pipeline",
        measures: "hotovo bez návratu, neúspěšné běhy",
      },
      vratislav: {
        text: "Do repa se nedostane nic, co by ho poškodilo.",
        owns: "revize, merge gate, zdraví větví",
        measures: "návraty po mergi, čas na gate",
      },
      tester: {
        text: "Ověří, že to uživatel opravdu dostane, na běžícím prostředí.",
        owns: "ověření kritérií, důkazy",
        measures: "chyby nalezené před produkcí, čas v testu",
      },
      "log-triage": {
        text: "Chyby z provozu se dozvíme dřív než klient.",
        owns: "logy, alert tikety",
        measures: "podíl falešných poplachů, čas do tiketu",
      },
      "wiki-keeper": {
        text: "Dokumentace odpovídá aplikaci.",
        owns: "wiki projektů",
        measures: "zastaralé stránky",
      },
      analyst: {
        text: "Nic, co se domluví v e-mailu, chatu nebo na schůzce, se neztratí.",
        owns: "návrhy tiketů a času",
        measures: "přijaté návrhy",
      },
    },
    now: {
      title: "Teď",
      nothing: "Nic teď neběží.",
      alive: "Běží na {{instances}}, naposledy se ptal po práci",
      gone: "Žádná instance se 10 minut neptala po práci: neběží.",
      phase: "Fáze",
      lastRun: "Poslední běh",
      noRuns: "Zatím žádný dokončený běh.",
      since: "od",
      doing: "Úkon",
      lanes_one: "pracuje {{count}} lane",
      lanes_few: "pracují {{count}} lanes",
      lanes_other: "pracuje {{count}} lanes",
      runs: "Běhy",
    },
    hold: {
      paused: "Pozastavený: nebere práci.",
      draining: "Probíhá nasazení: nebere novou práci.",
      limited: "Čeká na limit předplatného do",
      accessError: "Přístup odmítnut: {{error}}",
    },
    queue: {
      title: "Fronta",
      intro:
        "Otevřené tikety, které drží, v pořadí, v jakém je bere: nejdřív to, co běží, pak co vezme dál, nakonec to, na čem nepracuje.",
      count_one: "{{count}} tiket",
      count_few: "{{count}} tikety",
      count_other: "{{count}} tiketů",
      flagged_one: "{{count}} chce pozornost",
      flagged_few: "{{count}} chtějí pozornost",
      flagged_other: "{{count}} chce pozornost",
      empty: "Nedrží žádný otevřený tiket.",
      loadFailed: "Frontu se nepodařilo načíst.",
      open: "Otevřít frontu",
      waits: "bez pokroku {{age}}",
      flags: {
        running: "Právě pracuje",
        wrongState: "V tomhle stavu nepracuje",
        parked: "Čeká na závislost",
        note: "Stojí",
        escalate: "Stojí, jde na člověka",
        handover: "Čeká na předání",
        plan: "Plán k posouzení",
        fallback: "Jen když nemá nic jiného",
        recent: "Právě běžel, jde za ostatní",
        fallbackFree: "Jen když nemá nic jiného, teď je na řadě",
        backoff: "Čeká po neúspěšných pokusech",
        criteria: "Čeká na schválená kritéria",
      },
    },
    age: {
      minutes_one: "{{count}} minutu",
      minutes_few: "{{count}} minuty",
      minutes_other: "{{count}} minut",
      hours_one: "{{count}} hodinu",
      hours_few: "{{count}} hodiny",
      hours_other: "{{count}} hodin",
      days_one: "{{count}} den",
      days_few: "{{count}} dny",
      days_other: "{{count}} dní",
    },
  },
};
